<!--  获取抽卡次数-->
<template>
  <div class="drawCardNumber" v-if="onNumberShow">
    <div class="contentPop">
      <img
        @click="onClose"
        class="closed"
        src="https://iqh-zt-pord-cdn.iqihang.com/xunbao/closed.png"
        alt=""
      />
      <div class="titBg">
        <img
          src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/collectCard/drawtitImg.png"
          alt=""
        />
      </div>
      <h3>恭喜获得抽卡次数</h3>
      <div class="joinBtn" @click="toJoin">去抽卡</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    onNumberShow: Boolean
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    toJoin() {
      // this.$router.push('/collectCardIndex');
       this.$emit('showNumberFn',1);
    },
    onClose() {
      this.$emit('showNumberFn',0);
    },
  },
};
</script>
<style lang="scss" scoped>
.drawCardNumber {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  background: rgba($color: #000, $alpha: 0.8);
  .contentPop {
    position: relative;
    top: 50%;
    width: 634px;
    margin: 0 auto;
    padding-bottom: 50px;
    // height: 583px;
    background: #fff;
    border-radius: 36px;
    transform: translateY(-50%);

    .titBg {
      width: 100%;
      padding-top: 80px;
      background: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/collectCard/drawNumber.png')
        no-repeat;
      background-size: 100% 100%;
      img {
        display: block;
        width: 120px;
        height: 120px;
        margin: 0 auto;
      }
    }
    .closed {
      position: absolute;
      top: 30px;
      right: 30px;
      width: 24px;
      height: 24px;
    }
    h3 {
      margin: 44px 0 80px;
      color: #000;
      font-weight: 400;
      font-size: 28px;
      text-align: center;
    }
    .joinBtn {
      width: 324px;
      height: 76px;
      margin: 0 auto;
      color: #fff;
      font-weight: 500;
      font-size: 32px;
      line-height: 76px;
      text-align: center;
      background: #ff7f41;
      border-radius: 50px;
    }
  }
}
</style>
